module.exports = __webpack_public_path__ + "static/media/homeImage.2b923fbb.jpg";